import axiosInstance from '../shared/api/axios-instance';

export async function getUserBasket(userId) {
  return axiosInstance({
    method: 'POST',
    url: 'user/getUserBasket',
    data: {
      userId
    }
  });
}

export async function getUsersCompanyBasket(userId) {
  return axiosInstance({
    method: 'POST',
    url: 'user/getUserCompanyBasket',
    data: {
      userId
    }
  });
}

export async function getVertragsdocumente(pagination: object = {}, AccountId: string | null = null) {
  return axiosInstance({
    method: 'POST',
    url: 'user/GetVertragsdocumente',
    data: {
      AccountId,
      pagination,
      sort: {
        predicate: 'createdon',
        reverse: true
      }
    },
    transformResponse(data) {
      return data ? JSON.parse(data) : null;
    }
  });
}

export async function sendNotification(ConfigId, ContactId) {
  return axiosInstance({
    method: 'POST',
    url: 'user/sendnotification',
    data: {
      ConfigId
    }
  });
}

export async function deactivateUser(data) {
  return axiosInstance({
    method: 'DELETE',
    url: 'user',
    data
  });
}

export async function getUser(id) {
  return axiosInstance({
    method: 'GET',
    url: 'user',
    params: {
      id
    }
  });
}

export async function updateUserFahrzeug(data) {
  return axiosInstance({
    method: 'PUT',
    url: 'user/assigncar',
    data
  });
}

export async function inviteDriverAgain(ContactId) {
  return axiosInstance({
    method: 'POST',
    url: 'user/invite',
    data: {
      ContactId
    }
  });
}

export async function removeAvatar(ContactId) {
  return axiosInstance({
    method: 'POST',
    url: 'user/removeavatar',
    data: {
      ContactId
    }
  });
}

export const getDocumentTemplates = async params => {
  return axiosInstance({
    method: 'POST',
    url: 'company/documenttemplates',
    data: {
      ContactId: params
    }
  });
};

export const uploadAnwaltsvollmachtDocuments = async files => {
  const data = new FormData();
  files.forEach(file => {
    data.append('Files', file);
  });

  return axiosInstance({
    method: 'POST',
    url: 'user/UploadAnwaltsvollmachtDocuments',
    data
  });
};

export const setUserLastSingIn = async () => {
  return axiosInstance({
    method: 'POST',
    url: '/user/SetUserLastSingIn',
    data: {}
  });
};

export const createInviteUser = async data => {
  return axiosInstance({
    method: 'POST',
    url: 'user/CreateInviteUser',
    data
  });
};

export const getLocations = async () => {
  return axiosInstance({
    method: 'GET',
    url: 'standort/GetLookupCompanyList'
  });
};

export const getMobilityTypes = async () => {
  return axiosInstance({
    method: 'POST',
    url: 'crmentity/GetOptionSetValues',
    data: {
      entityName: 'contact',
      field: 'uds_mobilitatsart'
    }
  });
};

export const getDriverLicenceClasses = async () => {
  return axiosInstance({
    method: 'POST',
    url: 'crmentity/GetOptionSetValues',
    data: {
      entityName: 'contact',
      field: 'uds_fuhrerscheinklassen'
    }
  });
};

export const archiveUserDocument = async id => {
  try {
    const url = 'user/deleteUserDocument';
    await axiosInstance({
      method: 'DELETE',
      url,
      params: {
        fileid: id
      }
    });
  } catch (error) {
    console.log(error);
  }
};

export const checkEmail = async email => {
  try {
    const url = 'user/checkExisting';

    return axiosInstance({
      method: 'GET',
      url,
      params: {
        email
      }
    });
  } catch (error) {
    console.log(error);
  }
};
